/**
 * Reusable stateless form component for CourseCertificate
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { TextInput } from '../../../global/components/forms';

function CourseCertificateForm({
  cancelLink
  , formHelpers
  , formTitle
  , formType
  , handleFormChange
  , handleFormSubmit
  , courseCertificate
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Course Certificate" : "Update Course Certificate";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="courseCertificateForm" className="courseCertificate-form" onSubmit={handleFormSubmit}>
            {header}
            <TextInput
              change={handleFormChange}
              label="Name"
              name="courseCertificate.name"
              placeholder="Name (required)"
              required={true}
              value={courseCertificate.name}
            />
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

CourseCertificateForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formHelpers: PropTypes.object
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , courseCertificate: PropTypes.object.isRequired
}

CourseCertificateForm.defaultProps = {
  formHelpers: {}
  , formTitle: ''
}

export default CourseCertificateForm;



// WEBPACK FOOTER //
// modules/courseCertificate/components/CourseCertificateForm.js.jsx